import { EventBus, Events } from '@/eventbus/EventBus'
import { useRootStore } from '@/stores/store'
import { useFileListStore } from '@/stores/FileList.store'
import router from '@/router'

if (!EventBus._hasLoginHandler) {
  EventBus._hasLoginHandler = true

  EventBus.on(Events.LOGGED_IN, async () => {
    const store = useRootStore()
    useFileListStore().clear()
    if (store.state && store.state.redirectAfterLogin) {
      await router.push(store.state.redirectAfterLogin)
      store.setredirectAfterLogin(undefined)
    }
  })
}
